<template>
  <div class="hotel-admin">
    <head-nav></head-nav>
    <div class="content">
      <left-column></left-column>
      <div class="content-box">
        <keep-alive v-if="!$route.params.refresh">
          <router-view/>
        </keep-alive>
        <router-view v-if="$route.params.refresh"/>
      </div>
    </div>
  </div>
</template>
<script>
    import HeadNav from './component/head-nav/index.vue'
    import LeftColumn from './component/left-column/1.0.1/index.vue'

    export default {
        data() {
            return {}
        },
        methods: {},
        created() {
        },
        components: {HeadNav, LeftColumn}
    }
</script>
<style lang="less" scoped>
  .hotel-admin {
    width: 1200px;
    margin: auto;

    .content {
      display: flex;

      .content-box {
        width: calc(1200px - 170px);
        flex: 1;
        margin-left: 25px;
      }
    }
  }
</style>
